import styled from 'styled-components';
import { colors, font, breakpoints, spacing } from '@chegg-ui/theme';
var dark = colors.dark;
var family = font.family,
  _font$size = font.size,
  px14 = _font$size.px14,
  px20 = _font$size.px20,
  medium = font.weight.medium,
  lineHeight = font.lineHeight;
export var ValuePropsContainer = styled.div.withConfig({
  componentId: "sc-16f4pgy-0"
})(["font-family:", ";color:", ";width:100%;@media (max-width:", "){.vp-list{margin-top:10px;}}.vp-list svg{margin-top:5px;}.vp-list-item p{margin:0;}"], family.aspira, dark, breakpoints.sm.max);
export var HeaderContainer = styled.div.withConfig({
  componentId: "sc-16f4pgy-1"
})(["display:flex;flex-direction:row;align-items:flex-end;gap:", ";margin-bottom:", ";h2{margin:0;font-weight:", ";font-size:", ";}"], spacing.px12, spacing.px16, medium, px20);
export var Footer = styled.p.withConfig({
  componentId: "sc-16f4pgy-2"
})(["font-size:", ";margin:5px 0 0 0;line-height:", ";"], px14, lineHeight.sm);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ValuePropositions/styled.js
// module id = 4046
// module chunks = 11